<template>

	<section v-if="order && product">

        <section class="col-7 order">

			<header class="header margin-b-50 padding-b-50 border-b">

				<h1>Ordre</h1>

				<p>Nedenfor kan du se den valge menu og evt. tilkøb.</p>

			</header>

			<section class="col-12 content margin-b-75 padding-b-75 border-b">

				<section class="col-12 margin-b-100">

					<h1>{{product.title}} ({{order.details.quantity}} stk.) <span dusk="product-price">{{stripeAmount(productPrice).amount}},-</span></h1>

					<template v-for="selection in selectionsFiltered">
						<h2>{{selection.title}}</h2>
						<ul>
	                        <template v-for="option in selection.options">
	                            <li v-if="option.premium">{{option.title}} ({{option.quantity}} stk. á  {{stripeAmount(option.price).amount}},-) <span> {{stripeAmount(option.price).amount * option.quantity}},-</span></li>
	                            <li v-else>{{option.title}} ({{option.quantity}} stk.)</li>
	                        </template>
	                        <li v-if="selectionHasPremiumSelected(selection)" class="premium-total">Total  <span>{{stripeAmount(selectionSelectedPremiumOptionsTotal(selection)).amount}},-</span></li>
						</ul>
					</template>

				</section>

				<section class="col-12 margin-b-100" v-if="extraSelectionsFiltered.length > 0">

					<h1>Tilkøb </h1>

					<template v-for="selection in extraSelectionsFiltered">
						<h2 v-if="selection.options.length > 0">{{selection.title}}</h2>
						<ul>
							<li v-for="option in selection.options">{{option.title}} ({{option.quantity}} stk. á {{stripeAmount(option.as_extra_price).amount}},-) <span> {{stripeAmount(option.as_extra_price).amount * option.quantity}},-</span></li>
	                        <li class="premium-total" v-if="selection.options.length > 0">Total  <span>{{stripeAmount(selectionSelectedExtraOptionsTotal(selection)).amount}},-</span></li>
						</ul>
					</template>

				</section>

				<section class="col-12 margin-b-100">

					<h1>Miljø- og emballageafgift <span>{{stripeAmount(packaging).amount}},-</span></h1>
                    <p>({{stripeAmount(packaging_fee).amount}},- pr. stk)</p>

				</section>

                <section class="col-12" v-if="energy_fee !== null">

                    <h1>Energiafgift <span>{{stripeAmount(energy).amount}},-</span></h1>
                    <p>({{stripeAmount(energy_fee).amount}},- pr. stk)</p>

                </section>

	            <section class="col-12 margin-b-100" v-if="order.delivery.with_delivery">

	                <h1>Levering <span>{{stripeAmount(order.delivery.delivery_fee).amount}},-</span></h1>

	            </section>

				<section class="col-12">

					<h1>Pris</h1>

					<h3>Samlet pris <span>{{stripeAmount(total).amount}},-</span></h3>

				</section>

			</section>

			<section class="col-12 flex--space">

				<router-link :to="{name:'make-order.custom.product'}">Tilbage</router-link>

				<a class="btn--primary btn--sm primary--copper" href="#" @click.prevent="goToInformations" dusk="summary-done">Gå til Oplysninger</a>

			</section>

		</section>

	</section>

</template>

<script>
	import {mapGetters} from 'vuex';
	import totalCalculation from './../mixins/customTotalCalculation';
    export default {
        name: "order-summary",
		mixins: [totalCalculation],
		computed:{
			...mapGetters({
				order:'order',
				product:'product',
				packaging_fee:'packaging_fee',
                energy_fee:'energy_fee',
			}),
			selectionsFiltered(){
			    return this.product.selections.map(item => {
			       const selected = this.order.details.selections.find(selection => selection.selection_id == item.id);
			       return {
			           title: item.title,
                       options: selected.options.map(option => {
                           const optionData = item.options.find(optionItem => optionItem.id === option.id);
                           return {
                               title: optionData.title,
                               quantity: option.quantity,
                               price: optionData.price,
                               premium: option.premium,
                               packaging_price: option.packaging_price,
                           }
                       }),
				   }
				});
			},
			extraSelectionsFiltered(){
                return this.product.extra_selections.map(item => {
                    const selected = this.order.details.extra_selections.find(selection => selection.extra_selection_id == item.id);
                    if(selected.options.length > 0){
                        return {
                            id: item.id,
                            title: item.title,
                            options: selected.options.map(option => {
                                const optionData = item.options.find(optionItem => optionItem.id === option.id);
                                return {
                                    title: optionData.title,
                                    quantity: option.quantity,
                                    price: optionData.price,
                                    as_extra_price: optionData.as_extra_price,
                                    packaging_price: optionData.packaging_price,
                                }
                            }),
                        }
                    }

                    return null

                }).filter(item => item !== null);
			}
		},
		methods:{
			goToInformations(){
                this.$store.dispatch('completedSummary');
                this.$router.push({name:'make-order.custom.order.information'});
			}
		}
    }
</script>

<style scoped>

</style>
